import FindDuplicates from './container/index';

export default FindDuplicates;


// WEBPACK FOOTER //
// ./src/views/FindDuplicates/index.js